const Icons = {
    createAction: 'pen square',
    readAction: 'file alternate',
    updateAction: 'sync',
    deleteAction: 'trash alternate'
}

export default Icons